export const introduce = {
  text: '从交易所地址转出的代币总数',
  height: 1200,
};
